import React, { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { FaWhatsapp, FaUser , FaHeadset} from "react-icons/fa";
import GoogleMapCom from "../../pages/GoogleMapCom";
import { Carousel } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

import img1 from "../../images/awadh pase 2/ayushi-awadh-clubhouse-aerial.jpg";
import img2 from "../../images/awadh pase 2/ayushi-awadh-decorative-entrance-wall.jpg";
import img3 from "../../images/awadh pase 2/ayushi-awadh-entrance-gate-hero.jpg";
import img4 from "../../images/awadh pase 2/ayushi-awadh-floorplan-first-floor.jpg";
import img5 from "../../images/awadh pase 2/ayushi-awadh-floorplan-ground-floor.jpg";
import img6 from "../../images/awadh pase 2/ayushi-awadh-floorplan-second-floor.jpg";
import img7 from "../../images/awadh pase 2/ayushi-awadh-garden-walkway.jpg";
import img8 from "../../images/awadh pase 2/ayushi-awadh-mandir-aerial.jpg";
import img9 from "../../images/awadh pase 2/ayushi-awadh-sports-court-aerial.jpg";
import img10 from "../../images/awadh pase 2/ayushi-awadh-villa-row-dusk.jpg";
import img11 from "../../images/awadh pase 2/ayushi-awadh-villa-row-front.jpg";

const carouselImages = [img3, img2, img1, img7, img8, img9, img11, img10, img5, img4, img6];

function Ayushi_Awadh_Phase_2() {
  const [loading, setLoading] = useState(true);

  const amenities = [
    "Grand Entrance Gate (RERA approved)",
    "Decorative Entrance/Boundary Wall",
    "Club House (multi-storey, rooftop terrace)",
    "Swimming Pool",
    "Gym/Open Gym",
    "Yoga and Meditation Space",
    "Multi Gaming Courts ",
    "Children's Play Area",
    "Amphitheater",
    "Jogging Tracks/Walking Zone",
    "Landscaped Gardens (multiple zones)",
    "Beautiful Gazebo in Garden",
    "Beautiful Sculptures",
    "Mandir (Temple)",
    "CCTV Covered Campus",
    "Drainage System",
    "Electricity Supply",
    "RCC Wide Road",
    "In-township Convenience Shop plot"
  ];

  const specifications = [
    "Construction with fly ash bricks and M sand",
    "ISI TMT iron Saria",
    "Flush Door",
    "False Ceiling",
    "Personal water tank 1000 ltr. capacity",
    "Personal Borewell with 1/2 HP Submersible Pump",
    "Double charged vitrified flooring tiles 2'x4'",
    "Window MS steel grill with three-track UPVC section, tuffan glass",
    "Granite panelling on doors",
    "Double coat putty finish, one coat primer + double coat glossy/normal paint",
    "Wiring & modular switches (Anchor/Great White)",
    "Modular kitchen with chimney",
    "Jaquar sanitary fittings",
    "Quba/Godrej locks and handles",
    "SS Grill on stairs",
    "Anti-skid tiles in balcony/washroom 2'x4'",
    "Parking tiles 12mm 16\"x16\"",
    "MS Gate",
    "Tukdi roof protection for water leakage"
  ];

  const sampleHouse = [
    "Ground Floor — Parking, Entrance Foyer, Living, Dining, Kitchen, Open/Wash, Bedroom, Toilet",
    "First Floor — 2 Bedrooms (each with Dress area), 2 Toilets, Lobby, Balcony",
    "Second Floor — Bedroom with Dress area, Toilet, Lobby, Terrace"
  ];

  return (
    <Wrapper>
      <Helmet>
        <title>Ayushi Awadh Phase 2 | Premium Residential Plots in Jabalpur</title>
        <meta
          name="description"
          content="Ayushi Awadh Phase 2 offers premium residential plots in a RERA-approved, secure gated township by Ayushi Construction in Jabalpur. Explore our world-class amenities."
        />
        <meta
          name="keywords"
          content="ayushi awadh phase 2 jabalpur, residential plots jabalpur, gated township jabalpur, premium plots dhanwantari nagar"
        />
        <link
          rel="canonical"
          href="https://ayushiconstruction.com/ayushi-awadh-phase-2"
        />
      </Helmet>

      <div className="container">
        <div className="row mt-5 g-4 mb-5">
          <div className="col-lg-6 mt-5">
            <div
              className="about-content s-about-content pl-30"
              data-aos="fade-right"
            >
              <div className="about-title second-atitle">
                <h2>Ayushi Awadh Phase 2</h2>
                <h6 style={ { color: '#f26a20' } }>it's premium, it's private</h6>
              </div>

              <p>
                Welcome to Ayushi Awadh Phase 2, a premium and private residential plot
                development by Ayushi Construction. Spread across a RERA-approved, secure
                gated township, Ayushi Awadh offers individually numbered residential plots
                designed for homebuyers who want to build their dream residence in a
                well-planned, amenity-rich environment. The project welcomes residents
                through a grand, RERA-approved entrance gate and decorative boundary wall,
                opening into a community with a dedicated multi-storey clubhouse with
                rooftop deck and swimming pool, a temple (Mandir), multiple landscaped
                gardens with sculptures and gazebos, and an extensive range of sports and
                recreation facilities — including multi gaming courts, a children's play
                area, jogging tracks, an amphitheater, and a skating area. With CCTV covered
                campus, wide RCC roads, dedicated drainage and electricity infrastructure,
                and even an in-township convenience shop, Ayushi Awadh Phase 2 is designed
                as a complete, self-sufficient private community.
              </p>
            </div>
            <div className="row mt-3">
              <div className="col-md-6">
                <li>
                  <strong>Developer : - </strong>Ayushi Construction
                </li>
                <li>
                  <strong>RERA Reg. No. : - </strong>P-JBP-266365
                </li>
                <li>
                  <strong>Site Address : - </strong>Off Purwa Road / Dhanwantari Nagar Road area, Jabalpur (near M.P. Medical Science University & Medical College Jabalpur).
                </li>



              </div>
              <div className="col-md-6">

                <li>
                  <strong>Project Type : - </strong>Residential Plots
                </li>
                <li>
                  <strong>No. of Units : - </strong>97 numbered residential plots (Plot Nos. 1–97)
                </li>

                <li>
                  <strong>Status : - </strong>RERA Approved — Ongoing
                </li>

              </div>
            </div>
          </div>
          <div className="col-lg-6 mt-5">
            <div className="s-about-img p-relative" data-aos="fade-left">
              <Carousel>
                { carouselImages.map((imgSrc, index) => (
                  <Carousel.Item key={ index }>
                    <img
                      className="d-block w-100 imgset"
                      src={ imgSrc }
                      alt={ `Ayushi Awadh Phase 2 Slide ${index + 1}` }
                      style={ { objectFit: "cover", borderRadius: "10px", height: "450px" } }
                    />
                  </Carousel.Item>
                )) }
              </Carousel>
            </div>
          </div>

          {/* YouTube Video Tour Section */ }
          <div className="col-lg-12 mt-5 text-center">
            <h2>Watch Video Tour</h2>
            <div
              className="underline mx-auto"
              style={ {
                height: 3,
                width: "3rem",
                backgroundColor: "#34495E",
                marginTop: 10,
                marginBottom: 30,
              } }
            ></div>
            <div style={ { maxWidth: '800px', margin: '0 auto' } }>
              <div className="video-responsive" style={ { position: 'relative', overflow: 'hidden', paddingTop: '56.25%', borderRadius: '10px' } }>
                <iframe
                  style={ { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' } }
                  src="https://www.youtube.com/embed/MysHoB9pjc8"
                  title="Ayushi Awadh Phase 2 Video Tour"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen>
                </iframe>
              </div>
            </div>
          </div>

          <div className="col-lg-12 mt-5">
            <h2>AMENITIES</h2>
          </div>
          { amenities.map((amenity, index) => (
            <div className="col-lg-3 mt-2" key={ index }>
              <h6>{ amenity }</h6>
            </div>
          )) }

          <div className="col-lg-12 mt-5">
            <h2>SPECIFICATIONS</h2>
          </div>
          { specifications.map((spec, index) => (
            <div className="col-lg-3 mt-2" key={ index }>
              <h6>{ spec }</h6>
            </div>
          )) }

          <div className="col-lg-12 mt-5">
            <h2>SAMPLE HOUSE DESIGN</h2>
          </div>
          { sampleHouse.map((houseInfo, index) => (
            <div className="col-lg-12 mt-2" key={ index }>
              <h6>{ houseInfo }</h6>
            </div>
          )) }

          <div className="col-lg-12 mt-5">
            <GoogleMapCom locationUrl="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3668.9709326397283!2d79.86601557603863!3d23.134737712131795!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3981b37bf7c868c9%3A0xb7bbcfdd18689f62!2sAyushi%20Dhara!5e0!3m2!1sen!2sin!4v1742816322465!5m2!1sen!2sin" />
          </div>

          <div className="container text-center mt-5">
            <div className="h4" style={ { color: " #f26a20" } }>
              Let us connect{" "}
            </div>
            <div
              className="underline mx-auto"
              style={ {
                height: 3,
                width: "3rem",
                backgroundColor: "#34495E",
                marginTop: 20,
                marginBottom: 20,
              } }
            ></div>
            <div className="d-flex justify-content-center align-items-center gap-5 mt-4">
              <div className="text-center">
                <a
                  href="https://wa.me/919575809888?text=Hi!%20I%20came%20across%20the%20Ayushi%20Awadh%20project%20phase-2%20on%20your%20website,%20and%20I%E2%80%99m%20interested%20in%20exploring%20more%20about%20it.%20Could%20we%20discuss%20the%20details?"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none text-dark"
                >
                  <div style={ {
                    width: '60px',
                    height: '60px',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                  } }>
                    <FaWhatsapp size="35px" color="#25D366" />
                  </div>
                  <p className="mt-2 mb-0 fw-bold" style={ { fontSize: '14px' } }>Chat on WhatsApp</p>
                </a>
              </div>

              <div className="text-center">
                <Link to="/contact" className="text-decoration-none text-dark" onClick={ () => window.scrollTo(0, 0) }>
                  <div style={ {
                    width: '60px',
                    height: '60px',
                    backgroundColor: 'white',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto',
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                  } }>
                    <FaHeadset size="30px" color="#f26a20" />
                  </div>
                  <p className="mt-2 mb-0 fw-bold" style={ { fontSize: '14px' } }>Contact Us</p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}

export default Ayushi_Awadh_Phase_2;

const Wrapper = styled.div`
  img {
    width: 100%;
  }

  h6 {
    /* color:  #f26a20; */
  }
  h2 {
    color: #f26a20;
  }
  .card-title {
    color: #f26a20;
  }
  .container {
    margin-top: 6rem;
  }

  p {
    text-align: justify;
  }
`;
